import React from "react";
import HomeHeader from "components/home/HomeHeader";
import HomeFeatures from "components/home/HomeFeatures";
import HomeShowcase from "components/home/HomeShowcase";
import HomeGetStarted from "components/home/HomeGetStarted";
import HomeQuestions from "components/home/HomeQuestions";
import { FadeInSection } from "components/general/FadeInSection";
import Blog from "components/home/Blog";

export default function Home() {
  return (
    <div style={{ position: "relative" }}>
      <HomeHeader />
      <FadeInSection>
        <HomeFeatures />
      </FadeInSection>
      <FadeInSection>
        <HomeShowcase />
      </FadeInSection>
      <FadeInSection>
        <HomeQuestions />
      </FadeInSection>
      <FadeInSection>
        <HomeGetStarted />
      </FadeInSection>
      <FadeInSection>
        <Blog />
      </FadeInSection>
    </div>
  );
}
